import { StoreWallInterface } from "../../types/store";

interface IncomingPropsInterface {
    currentShelving: StoreWallInterface;
    connectorYPositions: number[];
    sectionId: string;
    isFirstRack?: boolean;
}

export const getSectionConnectorYPos = ({ currentShelving, connectorYPositions, sectionId, isFirstRack }: IncomingPropsInterface) => {
    const newConnectorYPositions = {...currentShelving.connectorYPositions};
    currentShelving.sections.forEach((section) => {
        if (section.isIndent) {
            return
        }
        if (section.id !== sectionId) {
            return section;
        } else {
            if (isFirstRack) {
                newConnectorYPositions[sectionId + 'firstRack'] = [...connectorYPositions];
                return;
            }
            newConnectorYPositions[sectionId] = (connectorYPositions);
        }
    });
    return newConnectorYPositions
};
